/* global FavoritesEnabled */

import _ from 'lodash';
import { PageNames, SegmentSources, tealiumEventPageTypes } from '@foxcorp/delta-web-analytics';
import { getShowType } from 'helpers/ContentHelper';

const getFavoriteData = ({ item }) => {
  const {
    categoryType,
    favoritableItems,
    name,
    network,
    seriesName,
    seriesType,
    showCode,
    trackingData,
    videoType,
  } = item;
  let favoriteData;
  if (FavoritesEnabled) {
    const showType = getShowType({ videoType, seriesType });
    const isPersonality = categoryType && categoryType === 'personality';
    const recommendationId = _.get(trackingData, 'properties.recommendationId', '');
    favoriteData = {
      actionLocation: 'playlist',
      favoritableItems,
      favoriteType: isPersonality ? 'personality' : showType,
      location: _.get(tealiumEventPageTypes, PageNames.HOME),
      networkId: network,
      recommendationId,
      seriesName: seriesName || name,
      showID: showCode,
      showType,
      source: SegmentSources.DETAIL,
    };
  }
  return favoriteData;
};

export default getFavoriteData;
